// src/components/ReduxProvider.tsx
"use client";

import React from "react";
import { Provider } from "react-redux";
import store from "../store/store"; // ✅ default import, no .ts or .tsx

export default function ReduxProvider({ children }: { children: React.ReactNode }) {
  return <Provider store={store}>{children}</Provider>;
}
